import { createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
import ShipAddressEN from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/locales/ShipAddress_en_US';
import ShipAddressFR from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/locales/ShipAddress_fr_CA';

const getText = getLocalisedDataFromResource(ShipAddressEN, ShipAddressFR);

export const newShipAddressModalSelector = createStructuredSelector({
    selectNewDefaultAddress: getTextFromResource(getText, 'selectNewDefaultAddress'),
    selectNewDefaultAddressLabel: getTextFromResource(getText, 'selectNewDefaultAddressLabel'),
    defaultAddressUpdated: getTextFromResource(getText, 'defaultAddressUpdated'),
    defaultAddressUpdatedTitle: getTextFromResource(getText, 'defaultAddressUpdatedTitle')
});
